import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import {
    Anchor,
    Button,
    Spacer,
    Text,
} from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';

import ListingActivationTerms from 'app/shared/components/ListingActivationTerms';

import {
    StyledUpsellContainer,
} from './StyledComponents';

const propTypes = {
    upsellType: PropTypes.oneOf(['None', 'Applications', 'Leases']),
    onEnableApplications: PropTypes.func.isRequired,
    onEnableLeases: PropTypes.func.isRequired,
};

const defaultProps = {
    upsellType: 'None',
};

const PostPublishUpsell = ({
    upsellType,
    onEnableApplications,
    onEnableLeases,
}) => {
    const { paths } = useContext(RMWContext);

    const postActivationConfigs = {
        Applications: {
            title: 'Save time with online applications!',
            description: `Finding a great tenant is easier with applications and screening tools all in
                    one place. Use our online application form with background check and credit
                    screening to find a renter quickly!`,
            learnMoreLink: paths.marketingRoutes.screening,
            onCTAClick: onEnableApplications,
            ctaText: 'Yes, enable applications',
        },
        Leases: {
            title: 'Get a head start on your next lease!',
            description: `Save time by preparing a lease agreement while you search for your perfect tenant.
                    Zillow’s online lease builder allows you to easily customize your lease using templates drafted
                    with local law firms.`,
            learnMoreLink: paths.onlineLeasesPage,
            onCTAClick: onEnableLeases,
            ctaText: 'Draft a lease',
        },
    };

    const config = postActivationConfigs[upsellType];

    if (upsellType === 'None') {
        return null;
    }

    return (
        <StyledUpsellContainer>
            <Text fontType="h6">{config.title}</Text>
            <Spacer paddingBottom="sm">
                <Text fontType="bodySmall">
                    {config.description}
                    &nbsp;
                    <Anchor
                        href={config.learnMoreLink}
                        target="_blank"
                    >
                        Learn more
                    </Anchor>
                    .
                </Text>
            </Spacer>
            <Spacer paddingBottom="sm">
                <Button
                    buttonType="primary"
                    onClick={config.onCTAClick}
                >
                    {config.ctaText}
                </Button>
            </Spacer>
            {upsellType === 'Applications' && (
                <ListingActivationTerms
                    actionText="By enabling applications"
                    noMargin={true}
                    isTextCenter={true}
                />
            )}
        </StyledUpsellContainer>
    );
};

PostPublishUpsell.propTypes = propTypes;
PostPublishUpsell.defaultProps = defaultProps;

export { PostPublishUpsell };
export default PostPublishUpsell;
